export class ShippingCommuneMapper {
    static toDto(shippingCommune: any): number[] {
        return shippingCommune.resultado.map((item: any) => {
            return item.idComuna;
        });
    }
}